import {
  AlignItems,
  Box,
  Color,
  Display,
  DisplayPosition,
  FlexDirection,
  FontFamily,
  Image,
  JustifyContent,
  Text,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'
import React from 'react'

export type CWCCollectionCardProps = {
  webp: string
  fallback: string
  caption: string
  /** Describes the photo scene — distinct from the caption, so both are announced. */
  alt: string
}

// Deliberately non-interactive (no anchor/onClick/hover) — mirrors EndlessVarietySection/Slide.
const CardSurface = withCitrusTheme(Box, () => ({
  borderRadius: '16px',
  overflow: 'hidden',
}))

const GradientOverlay = withCitrusTheme(Box, () => ({
  background: 'linear-gradient(180deg, rgba(33, 41, 48, 0) 39%, rgba(0, 0, 0, 0.8) 88%)',
}))

export function CWCCollectionCard({ webp, fallback, caption, alt }: CWCCollectionCardProps) {
  return (
    <CardSurface
      position={DisplayPosition.Relative}
      width={['220px', '220px', '220px', '230px']}
      height={['320px', '320px', '320px', '360px']}
    >
      <picture>
        <source srcSet={webp} type="image/webp" />
        <Image
          src={fallback}
          alt={alt}
          width="100%"
          height="100%"
          style={{ objectFit: 'cover' }}
          loading="lazy"
        />
      </picture>
      <GradientOverlay
        position={DisplayPosition.Absolute}
        bottom="0"
        left="0"
        right="0"
        top="0"
        display={Display.Flex}
        flexDirection={FlexDirection.Column}
        alignItems={AlignItems.FlexStart}
        justifyContent={JustifyContent.FlexEnd}
        paddingH={4}
        paddingV={8}
      >
        {/* size={7} = 20/28 on the Citrus font scale. */}
        <Text size={7} color={Color.White} fontFamily={FontFamily.Bold}>
          {caption}
        </Text>
      </GradientOverlay>
    </CardSurface>
  )
}
